module.exports = "pegasus/assets/social-2-basic.png";